import axios from 'axios';
import { apiClient } from 'client/core/network/apiClient';
import { ICreateAccessTokenDto } from 'common/dto/AuthDto';
import { ISpidProviderButton } from './login/open-web/spid-button/SpidLoginButton';

export const AuthApi = {
  /** Creazione dell'access token per il login */
  createAccessToken: (data: ICreateAccessTokenDto) =>
    apiClient.post('/auth/access-token', data),
  refreshToken: () => apiClient.post('/auth/refresh-token'),
  logout: () => apiClient.post('/auth/logout'),
  /** Recupero della lista dei provider SPID */
  listSpidProviders: () =>
    axios.get<ISpidProviderButton[]>(
      'https://registry.spid.gov.it/entities-idp?&output=json&custom=info_display_base'
    )
};
